import * as React from "react";
import Loading from "src/components/Common/Loading";

const ReportPageLoading = (): JSX.Element => {
  return <Loading height="100%" />;
};
export default ReportPageLoading;
